module.exports = __webpack_public_path__ + "static/media/metaFarms.f193af2f.png";